import { isAccountDisabled } from '@monorepo/client-types';
import { Account } from '@monorepo/types';

/**
 * Check if account polling should be disabled based on status and state.
 *
 * Polling is disabled when:
 * - Account status is disabled or waiting for risk
 * - Account state is terminated, daily pause, daily loss, or expired
 * - Target state allows polling (user can still trade)
 *
 * @param account - The account object to check
 * @returns true if polling should be disabled, false otherwise
 */
export const shouldDisablePolling = (account?: Account): boolean => {
  if (!account) return false;

  // Check general account status
  if (isAccountDisabled(account.status)) return true;

  // Check specific account states that should disable polling
  if (account.state?.terminated) return true;
  if (account.state?.dailyPause) return true;
  if (account.state?.dailyLoss) return true;
  if (account.state?.expired) return true;

  // Target state should still allow polling (user can continue trading)
  // Active/normal states should allow polling

  return false;
};
